import { SipPlanMode } from '../../../api/types'
import { SipPlansListErrorState } from '../../sip-ui-components/SipPlansListErrorState'

type IdealSipPlansListErrorStateProps = {
  onRetry: () => void
}

export function IdealSipPlansListErrorState({ onRetry }: IdealSipPlansListErrorStateProps) {
  return <SipPlansListErrorState planMode={SipPlanMode.IDEAL_SIPS} onRetry={onRetry} />
}
